import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const filterAccounts = (data, search) =>
  data.filter(
    ({ name, trial }) =>
      (name || '').toLowerCase().includes(search.toLowerCase()) ||
      (trial || '').toString().toLowerCase().includes(search.toLowerCase())
  );

export const filterAdmins = (data, search) =>
  data.filter(
    ({ firstName, lastName, email }) =>
      (firstName || '').toLowerCase().includes(search.toLowerCase()) ||
      (lastName || '').toLowerCase().includes(search.toLowerCase()) ||
      `${firstName} ${lastName}`.toLowerCase().includes(search.toLowerCase()) ||
      (email || '').toLowerCase().includes(search.toLowerCase())
  );

export const filterUsers = (data, search) =>
  data.filter(
    ({ firstName, lastName, phone }) =>
      (firstName || '').toLowerCase().includes(search.toLowerCase()) ||
      (lastName || '').toLowerCase().includes(search.toLowerCase()) ||
      `${firstName} ${lastName}`.toLowerCase().includes(search.toLowerCase()) ||
      ((phone ? parsePhoneNumberFromString(`+${phone}`)?.formatNational() : '') || '')
        .toLowerCase()
        .includes(search.toLowerCase())
  );

export const filterByName = (firstName, lastName, search) =>
  (firstName || '').toLowerCase().includes(search.toLowerCase()) ||
  (lastName || '').toLowerCase().includes(search.toLowerCase()) ||
  `${firstName} ${lastName}`.toLowerCase().includes(search.toLowerCase());

export const filterByPhone = (phone, search) => {
  if (!phone || !search) {
    return false;
  }

  const formatted = parsePhoneNumberFromString(`+${phone}`)?.formatNational() || '';
  if (formatted.toLowerCase().includes(search.toLowerCase())) {
    return true;
  }

  const searchDigits = search.replace(/\D/g, '');
  return !!searchDigits && (`${phone}`.includes(searchDigits) || formatted.replace(/\D/g, '').includes(searchDigits));
};

export const filterLogActions = (data, search) =>
  data.filter(
    ({ action, name, body }) =>
      (action || '').toLowerCase().includes(search.toLowerCase()) ||
      (name || '').toLowerCase().includes(search.toLowerCase()) ||
      (body || '').toLowerCase().includes(search.toLowerCase())
  );

export const filterByEmployees = (search, shifts, employeesMap) => {
  return shifts
    .reduce((input, { slots }) => {
      input.push(...slots);
      return input;
    }, [])
    .some(
      ({ employeeId }) =>
        employeeId &&
        employeesMap[employeeId] &&
        filterByName(employeesMap[employeeId].firstName, employeesMap[employeeId].lastName, search)
    );
};
